import styled from 'styled-components'

const LineBreak = styled.div`
  background-color: rgba(241, 241, 241, 0.3);
  height: 1px;
  width: 100%;
  margin: -13px 0 1.5em 0 ;
`

export default LineBreak